import { useMemo, useState } from "react";

import Button from "@/components/atom/Button";
import { PenEditSvg } from "@/public/svg";
import { toast } from "react-toastify";
import { MapComponent } from "@/components/atom/Map";
import { revalidateCustom, updateProfileSaya } from "@/functions/databaseData";
import useHeader from "@/functions/useHeader";
import { usePathname } from "next/navigation";

export default function Coordinates() {
  const path = usePathname();
  const { session, profile } = useHeader();
  const [coordinates, setCoordinates] = useState({});
  const [disable, setDisable] = useState(true);

  const handleSave = async () => {
    try {
      if (!profile?.address_information?.id_area)
        throw new Error("Lengkapi informasi alamat terlebih dahulu.");

      const countChange = profile.max_cange_info_address;
      const res = await updateProfileSaya({
        id: profile?.mitra_id,
        body: {
          address: profile?.address_information?.address,
          area_id: profile?.address_information?.id_area,
          name_location: profile?.name_store,
          longitude: coordinates?.lng,
          latitude: coordinates?.lat
        },
        event: "address",
        token: session?.user?.token,
        url_api:
        countChange > 0 && profile?.mitra_level == 1
            ? `mitra/${profile?.mitra_id}/request/update_profile?event=address`
            : `mitra/${profile?.mitra_id}/update?event=address`,
      });

      if (!res.error) {
        setDisable(!disable);
        revalidateCustom({ path });
        return countChange > 0 && profile?.mitra_level == 1
          ? toast.info(
              "Menunggu approval dari admin untuk perubahan koordinat",
              {
                position: "top-center",
              }
            )
          : toast.success(`Success melakukan update kordinat`, {
              position: "top-center",
            });
      }
      throw new Error(res?.error?.message || res?.error);
    } catch (error) {
      console.log(error?.message);
      toast.error(error?.message, {
        position: "top-center",
      });
    }
  };

  return (
    <div className="flex flex-col w-full bg-shadesGON-50 shadow-normalGON rounded-2xl p-4 gap-4 xs:p-8 xs:gap-8">
      <div className="flex flex-col xs:flex-row xs:items-center justify-between gap-2">
        <p className="subheading-semiBold text-greyscaleGON-400">
          Informasi Kordinat
        </p>
        {disable ? (
          <Button
            label="ubah"
            icon={{
              left: (props) => <PenEditSvg className={props.className} />,
            }}
            size="small"
            variants="outline"
            onClick={() => setDisable(false)}
          />
        ) : (
          <div className="flex flex-col-reverse xs:flex-row gap-4 items-center">
            <Button
              label="batal"
              size="small"
              variants="outline"
              onClick={() => setDisable(true)}
              className="flex w-full xs:w-auto"
            />
            <Button
              label="simpan"
              size="small"
              onClick={() => handleSave()}
              className="flex w-full xs:w-auto"
            />
          </div>
        )}
      </div>
      <div className="flex flex-col xs:flex-row xs:items-center gap-1">
        <p className="p3-regular text-greyscaleGON-400">
          latitude{" "}
          <span className="text-greyscaleGON-700">
            {coordinates?.lat?.toString() ||
              profile?.address_information?.location?.latitude}
          </span>
        </p>
        <p className="p3-regular text-greyscaleGON-400">
          longitude{" "}
          <span className="text-greyscaleGON-700">
            {coordinates?.lng?.toString() ||
              profile?.address_information?.location?.longitude}
          </span>
        </p>
      </div>
      {!disable && (
        <MapComponent
          handleCoordinates={(val) => !disable && setCoordinates(val)}
          defaultLocation={
            !profile?.address_information?.location?.latitude ||
            !profile?.address_information?.location?.longitude
              ? {
                  lat: -6.2634008,
                  lng: 106.7153196,
                }
              : {
                  lat: profile?.address_information?.location?.latitude,
                  lng: profile?.address_information?.location?.longitude,
                }
          }
        />
      )}
    </div>
  );
}
